export default __webpack_public_path__ + "static/media/435.d7a3effb.gif";